import AwsLogo from "../assets/Amazon.svg.png";
import Kubernetes from "../assets/kubernetes.png";
import Terraform from "../assets/terraform.png";


export const categoryLogos = {
  aws: AwsLogo,
  kubernetes: Kubernetes,
  terraform: Terraform,

  // terraform: TerraformLogo,
};
